import { ConstructionOutlined } from '@mui/icons-material';
import { api } from './api';


export const adminService = {
  getDashboard: () => api.get('/admin/dashboard'),

  // getAllBusinesses: (page = 0, limit = 10, search = '', status = '') =>
  //   api
  //     .get('/api/businesses', {
  //       params: {
  //         page: page + 1,
  //         limit,
  //         search,
  //         status: status === 'ALL' ? '' : status,
  //       },
  //     })
  //     .then((res) => res.data),

  getAllBusinesses: (page = 0, limit = 10, search = '', status = '') => {
  // If filtering for blocked businesses, use the specific endpoint
  console.log(status, 'status in service'); // Add this
    
  if (status === 'BLOCKED') {
      console.log('Calling blocked endpoint'); 
    return api
      .get('/api/businesses/blocked', {
        params: {
          page: page + 1,
          limit,
          search,
        },
      })
      .then((res) => res.data);
     
  }
  
  // Otherwise use the regular endpoint
   console.log('Calling regular endpoint with status:', status); // Add this
   
  return api
    .get('/api/businesses', {
      params: {
        page: page + 1,
        limit,
        search,
        status: status === 'ALL' ? '' : status,
      },
    })
    .then((res) => res.data);
},
  getBusiness: (id) =>
    api.get(`/api/business/${id}`).then((res) => res.data),

  createBusiness: (businessData) =>
    api.post('/api/business', businessData).then((res) => res.data),

  // updateBusiness: (tenantId, businessData) => 
  //   api.put(`/admin/business/${tenantId}`, businessData),

  // deleteBusiness: (tenantId) => api.delete(`/admin/business/${tenantId}`),

  // 🔐 Fetch decrypted secret key
  getBusinessSecret: (id) =>
    api.get(`/api/business/${id}/secret`).then(res => res.data),

  // Application CRUD
  createApplication: (tenantId, applicationData) => 
    api.post(`/admin/business/${tenantId}/applications`, applicationData),

  getBusinessApplications: (tenantId) => 
    api.get(`/admin/business/${tenantId}/applications`),

  getApplication: (appId) => api.get(`/admin/applications/${appId}`),

  updateApplication: (appId, applicationData) => 
    api.put(`/admin/applications/${appId}`, applicationData),

  getApplications: () => api.get('/admin/applications'),

  getApplicationToken: (appId) => 
    api.post(`/admin/applications/${appId}/token`),

  createBusinessUser: (tenantId, userData) => 
    api.post(`/admin/business/${tenantId}/users`, userData),

  // getBusinessUsers: (tenantId) => 
  //   api.get(`/admin/business/${tenantId}/users`),

  deleteUser: (userId) => 
    api.delete(`/admin/users/${userId}`),

  resetUserPassword: (userId) => 
    api.post(`/admin/users/${userId}/reset-password`),

  updateUser: (userId, userData) => 
    api.put(`/admin/users/${userId}`, userData),

  updateUserStatus: (userId, status) => 
    api.put(`/admin/users/${userId}/status`, { status }),

  
  // ✅ BLOCK BUSINESS - Add this
  blockBusiness: (tenantId, blockReason) =>
    api.put(`/api/business/${tenantId}/block`, { blockReason })
      .then(res => res.data),

  // ✅ UNBLOCK BUSINESS - Using PUT and tenantId
  unblockBusiness: (tenantId,reason) =>
    api.put(`/api/business/${tenantId}/unblock`, {unblockReason: reason})
      .then(res => res.data),


      // ✅ Update business (new)
  updateBusiness: (tenantId, data) =>
    api.put(`/api/business/${tenantId}`, data).then(res => res.data),

  // ✅ Delete business (new)
  deleteBusiness: (tenantId) =>
    api.delete(`/api/business/${tenantId}`).then(res => res.data),

// Inside the admin service object
  updateBusinessMetadata: (businessId, metadata) =>
    api.post(`/api/${businessId}/metadata`, metadata).then(res => res.data),

 getBusinessUsers: (tenantId, page, limit, search) =>
  api.get(`/api/admin/subscribers/${tenantId}/users`, {
    params: { page: page + 1, limit, search }
  }).then(res => res.data),

  // services/admin.js
getAdminStats: () =>
  api.get('/api/admin/subscribers/admin/stats').then((res) => res.data),

// Read-only list of every domain across a business's web apps
getBusinessDomains: (businessId) =>
  api.get(`/api/businesses/domains/${businessId}`).then(res => res.data),

getAllowlist: (businessId) =>
  api.get(`/api/admin/subscribers/allowed/${businessId}`).then(res => res.data),

addDomain: (businessId, domain) =>
  api.post(`/api/admin/subscribers/add/${businessId}`, { domain }).then(res => res.data),

removeDomain: (businessId, domain) =>
  api.delete(`/api/admin/subscribers/remove/${businessId}`, { data: { domain } }).then(res => res.data),

editDomain: (businessId, oldDomain, newDomain) =>
  api.patch(`/api/admin/subscribers/edit/${businessId}`, { oldDomain, newDomain }).then(res => res.data),

// New
getWhiteLabels: (businessId) =>
  api.get(`/api/admin/subscribers/whitelabel/${businessId}`).then(res => res.data),

upsertWhiteLabel: (domain, payload) =>
  api.put(`/api/admin/subscribers/whitelabel/domain/${encodeURIComponent(domain)}`, payload).then(res => res.data),

deleteWhiteLabel: (domain) =>
  api.delete(`/api/admin/subscribers/whitelabel/domain/${encodeURIComponent(domain)}`).then(res => res.data),

// ─── Application (BusinessApp) CRUD ────────────────────────────────

// One-shot create: details + domains + settings together. Nothing is
// written to the DB until this single call, so an abandoned wizard leaves
// no rows behind. payload:
//   { businessId, appName, appDescription, appType,
//     domains: [{ domainName, displayName, redirectUrl, logoUrl, enabled }],
//     settings: { blockDuration, failedAttemptsBeforeBlock, webhookUrl, metadata, enabled } }
createBusinessAppFull: (payload) =>
  api.post('/api/business-apps/full', payload).then(res => res.data),

updateBusinessApp: (appId, payload) =>
  // payload: { appName, appDescription }
  api.put(`/api/business-apps/${appId}`, payload).then(res => res.data),

getBusinessApp: (appId) =>
  api.get(`/api/business-apps/${appId}`).then(res => res.data),

// Accepts a single params object so callers can pass through the optional
// appName/appType/businessName/businessId filters the backend supports
// (businessApp.controller.js:getAllBusinessApps) alongside pagination.
getBusinessApps: ({ page = 1, limit = 10, appName, appType, businessName, businessId, search } = {}) =>
  api.get('/api/business-apps', { params: { page, limit, appName, appType, businessName, businessId, search } }).then(res => res.data),

getBusinessAppsByBusiness: (businessId, limit = 10) =>
  api.get(`/api/businesses/apps/${businessId}`, { params: { limit } }).then(res => res.data),

// Business self-service list: only the apps of `businessId` (the caller's own
// businesses._id — the backend 403s for any other business).
getOwnBusinessApps: (businessId, { page = 1, limit = 10, appName, appType } = {}) =>
  api.get(`/api/businesses/apps/${businessId}`, { params: { page, limit, appName, appType } }).then(res => res.data),

deleteBusinessApp: (appId) =>
  api.delete(`/api/business-apps/${appId}`).then(res => res.data),

// ─── Domains — keyed by domainName, there is NO domain id ─────────

addAppDomain: (appId, domainData) =>
  // domainData: { domainName, displayName, logoUrl, redirectUrl, enabled }
  api.post(`/api/business-apps/domains/${appId}`, domainData).then(res => res.data),

getAppDomain: (appId) =>
  api.get(`/api/business-apps/domains/${appId}`).then(res => res.data),

// currentDomainName = the name it's CURRENTLY saved under (needed for the URL)
updateAppDomain: (currentDomainName, appId, payload) =>
  api.put(`/api/business-apps/domains/${currentDomainName}/${appId}`, payload).then(res => res.data),

deleteAppDomain: (domainName, appId) =>
  api.delete(`/api/business-apps/domains/${domainName}/${appId}`).then(res => res.data),

// ─── Settings — one object per app, not per domain ─────────────────

addAppSettings: (appId, settings) =>
  api.post(`/api/business-apps/settings/${appId}`, settings).then(res => res.data),

getAppSettings: (appId) =>
  api.get(`/api/business-apps/settings/${appId}`).then(res => res.data),

updateAppSettings: (appId, settings) =>
  api.put(`/api/business-apps/settings/${appId}`, settings).then(res => res.data),

}
// services/adminService.js